import $ from 'jquery';
import Player from '@vimeo/player';

const modal = function modal() {
  const backgroundVideos = $('iframe[src*="background=1"]');
  const backgroundVideosPlayers = [];
  if (backgroundVideos && backgroundVideos.length) {
    backgroundVideos.each((i, el) => {
      backgroundVideosPlayers.push(new Player(el));
    });
  }

  const closeModal = modalEl => {
    modalEl.removeClass('active');
    setTimeout(() => {
      modalEl.fadeOut(300);
    }, 350);

    const modalIframe = modalEl.find('iframe');
    if (modalIframe) {
      const player = new Player(modalIframe[0]);
      player.pause();
    }

    $.each(backgroundVideosPlayers, (i, el) => {
      el.play();
    });
  };

  const $modalTrigger = $('[data-modal]');

  if ($modalTrigger.length) {
    $modalTrigger.click(ev => {
      ev.preventDefault();
      let $self = $(ev.target);
      let $modal = $self.data('modal');
      if (!$modal) {
        $self = $self.closest('[data-modal]');
        $modal = $self.data('modal');
      }
      $modal = $($modal);
      $modal.fadeIn(300);
      setTimeout(() => {
        $modal.addClass('active');
      }, 350);

      const modalIframe = $modal.find('iframe');
      if (modalIframe) {
        const player = new Player(modalIframe[0]);
        player.play();
      }

      $.each(backgroundVideosPlayers, (i, el) => {
        el.pause();
      });
    });

    const $modals = $('.modal');
    document.onkeydown = ev => {
      const evnt = ev || window.event;
      if (evnt.keyCode === 27) {
        closeModal($modals);
      }
    };

    const $modalClose = $('.modal--backdrop, .modal--close');
    if ($modalClose.length) {
      $modalClose.click(ev => {
        ev.preventDefault();
        closeModal($modals);
      });
    }
  }
};
export default modal;



// WEBPACK FOOTER //
// ./src/scripts/modules/modal.js